import axios from "axios";
import Api from "../../api";
import { MCP_REQUEST_OPTIONS } from "../../utils/mcpOAuth";

/* 重置密码函数 */
export const resetPasswordFunction = async (props) => {
    let {
        phone,
        captcha,
        password
    } = props;
    try {
        const data = {
            phone,
            verify_code: captcha,
            new_password: password,
        }
        const baseURL = `${process.env.REACT_APP_BASE_URL || window.location.origin}/api/`
        const res = await axios.put(`${baseURL}sys/password/retrieve/`, data);
        let success = res.data.code === 0;
        return {
            success,
            msg: res.data.msg,
        };
    } catch (error) {
        return {
            success: false,
            msg: error.message,
        };
    }
}

/* 账号密码登录 */
export const passwordLoginFunction = async (props) => {
    let {
        username,
        password
    } = props;
    try {
        const data = {
            phone: username,
            password,
        }
        const res = await Api.loginFunc(data, undefined, MCP_REQUEST_OPTIONS);
        let success = res.data.code === 0;
        return {
            success,
            msg: res.data.msg,
            ticket: res.data?.data?.ticket,
            data: res.data?.data,
        };
    } catch (error) {
        return {
            success: false,
            msg: '登录请求失败，请稍后重试。',
        };
    }
}

/* 手机号登录 */
export const phoneLoginFunction = async (props) => {
    let {
        phone,
        captcha
    } = props;
    try {
        const data = {
            phone,
            verify_code: captcha,
        }
        const res = await Api.loginFunc(data, undefined, MCP_REQUEST_OPTIONS);
        let success = res.data.code === 0;
        return {
            success,
            msg: res.data.msg,
            ticket: res.data?.data?.ticket,
            data: res.data?.data,
        };
    } catch (error) {
        return {
            success: false,
            msg: '登录请求失败，请稍后重试。',
        };
    }
}
